export const selectDesignationsList = (state) => state.designations.designations;
export const selectDesignationsLoading = (state) => state.designations.loading;
export const selectDesignationsError = (state) => state.designations.error;
export const selectDesignationsSuccessMessage = (state) =>
  state.designations.successMessage;
